<template>
<div>
  <template v-if="auto">
    Descargando...
  </template>
  <template v-else>
    <button @click="print">imprimir</button>
    <br />
    <body style="font-family: Arial; font-size: 13.5px;">
      <div class="print-container clearfix">
            <div class="flex-container">
              <div style="flex-grow: 1">
                <img id ="img1" class="invoice-logo" src="../../assets/img/logo2.png" alt=""  />
              </div>
            </div>
            <div class="flex-container">
              <div style="flex-grow: 6">
                <h5 style="text-align: center; padding-top: 18px; font-size: 20px">CHECK LIST INSPECCIÓN - SEGUIMIENTO PUNTOS DE FALLA REPORTADO Y/O PUNTOS EJECUTADOS</h5>
              </div>
            </div>

            <b-container class="bv-example-row">
              <b-row>
                <b-col sm style= "border: 1px solid #000;">Fecha Reportado: {{getProp('reported_date')}}</b-col>
                <b-col sm style= "border: 1px solid #000;">N° Orden de Manto (OM): {{getProp('om')}}</b-col>
                <b-col v-if="getPropDisplay('platform')!=''" sm style= "border: 1px solid #000;">Plataforma: {{getPropDisplay('platform')}}</b-col>
                <b-col v-else sm style= "border: 1px solid #000;">Flowline: {{getPropDisplay('flowline')}}</b-col>
                <b-col sm style= "border: 1px solid #000;">Fecha Inspección: {{getProp('inspection_date')}}</b-col>
                <b-col sm style= "border: 1px solid #000;">N° Inspección: {{getProp('inspection_n')}}</b-col>
                <b-col sm style= "border: 1px solid #000;">N° OM Reportado: {{getProp('om_r')}}</b-col>
              </b-row>
            </b-container>
      </div>

      <div class="print-container clearfix" >
          <div>
              <b-card-group deck>
                <b-card bg-variant="Secondary" text-variant="dark" header="Trabajos Provisionales" class="text-center">
                  <b-card-text style = "text-align: left;">Nro OM: {{getProp('om_pw')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Inicio: {{getProp('pw_start')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Fin: {{getProp('pw_end')}}</b-card-text>
                </b-card>

                <b-card bg-variant="Secondary" text-variant="dark" header="Trabajos Definitivos" class="text-center">
                  <b-card-text style = "text-align: left;">Nro OM: {{getProp('om_dw')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Inicio: {{getProp('dw_start')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Fin: {{getProp('dw_end')}}</b-card-text>
                </b-card>

                <b-card bg-variant="Secondary" text-variant="dark" header="Inspección Anterior" class="text-center">
                  <b-card-text style = "text-align: left;">Fecha: {{getPropPrev('inspection_date')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Supervisor: {{getPropPrev('supervisor')}}</b-card-text>
                </b-card>

                <b-card bg-variant="Secondary" text-variant="dark" header="Locación" class="text-center">
                  <b-card-text style = "text-align: left;">Cota: {{getProp('cota')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Este: {{Math.trunc(getProp('east_coordinate',0))}}</b-card-text>
                  <b-card-text style = "text-align: left;"> Norte: {{Math.trunc(getProp('north_coordinate',0))}}</b-card-text>
                </b-card>
              </b-card-group>
            </div>
      </div>

      <div class="print-container clearfix" >
          <div>
            <b-card-group deck>
              <b-card bg-variant="Secondary" text-variant="dark" header="Identificación" class="text-center">
                  <b-card-text v-if="getPropDisplay('instalation')!=''" style = "text-align: left;">Instalación: {{getProp('instalation')}}</b-card-text>
                  <b-card-text v-else style = "text-align: left;">Progresiva: {{getProp('progressive')}}</b-card-text>
                  <b-card-text v-if="getPropDisplay('talud')!=''" style = "text-align: left;">Instalación: {{getProp('talud')}}</b-card-text>
                  <b-card-text v-else style = "text-align: left;">Lado de DDV: {{getPropDisplay('side_to_ddv')}}</b-card-text>
                  <b-card-text style = "text-align: left;">Sección Transversal: {{getPropDisplay('section')}}</b-card-text>
              </b-card>
              <b-card bg-variant="Secondary" text-variant="dark" header="Otros (Cabecera)" class="text-center">
                  <!--<b-card-text style = "text-align: left;">Nr° Formato: {{getProp('format_n')}}</b-card-text>-->
                  <b-card-text style = "text-align: left;">Índice FRM Anterior: {{getPropPrev('ifrm_value')}}</b-card-text>
              </b-card>
            </b-card-group>
          </div>
      </div>

      <div class="print-container clearfix">
      <b-container class="bv-example-row">
        <b-row>
          <b-col sm style= "border: 1px solid #000;">Indice IFRM: {{getProp('ifrm_value')}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Nivel de Afectación: {{getAffectation().t}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Distancia al ducto: {{getProp('pipeline_distance') + 'm'}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Afectación deslizamiento: {{'L=' + getProp('landslide_length') + 'm A=' + getProp('landslide_width') + 'm Prof t=' + this.getProp('landslide_total_depth') + 'm'}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Área afectada: {{(Math.PI * Math.sqrt(Math.pow(this.getProp('landslide_length', 1), 2) - Math.pow(this.getProp('landslide_total_depth', 1), 2)) * this.getProp('landslide_width', 1) / 4).toFixed(2) + 'm2'}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Prof. Tapada: {{getProp('covered_depth') + 'm'}}</b-col>
          <b-col sm style= "border: 1px solid #000;">Tipo de Proceso: {{getPropDisplay('process_type')}}</b-col>
        </b-row>
      </b-container>

      </div>
      <!-- Creacion de tabla -->
      <div class="print-container clearfix">
        <div class = "flex-container " >
          <div style="flex-grow: 1;" >
              <table v-if="getProp('ifrm_table', null)" class="table table-hover ">
                  <thead>
                      <tr>
                        <td><b>Variables</b></td>
                        <td><b>Evaluación</b></td>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                        <td>Tipo de Suelo</td>
                        <td>{{getPropDisplay('soil_type')}}</td>
                      </tr>
                      <tr v-for ="i in getProp('ifrm_table') " v-bind:key="'ifrm_t'+(i+5)">
                        <td>{{i[0]}}</td>
                        <td>{{i[1]}}</td>
                      </tr>
                      <tr>
                        <td :style="bgcolor"><b>IFRM</b></td>
                        <td :style="bgcolor"><b>{{getProp('ifrm_value')}}</b></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>
      </div>

    <div class="print-container clearfix">
      <div class="flex-container" style="center">
        <div style="flex-grow: 1">
        </div>
        <div style="flex-grow: 1" v-if="loadchart && isMounted">
          <radar-chart id="chart1" ref="radar" :width="250" :height="250"
            :chart-data="chartdata" :options="chartoptions"/>
        </div>
      </div>
    </div>

    <div class="print-container clearfix">
      <div v-if="inspection.esquema || schema" >
        <span><b>Esquema/Plano de Punto de Falla</b></span>
      </div>
      <div class="flex-container" style="center">
        <div style="flex-grow: 1">
        </div>
        <div style="flex-grow: 1">
          <b-img thumbnail fluid v-for="(image, key, i) in (schema?schema:inspection.esquema)" v-bind:key="'img3_'+i" :id="'img3_'+(schema?key:i)"
          style="max-height:400px" class="img-fluid" :src="loadedFiles[key]" alt="Ninguno" :title="key" />
        </div>
        <div style="flex-grow: 1">
        </div>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div>
        <b-card-group deck>
          <b-card bg-variant="Secondary" text-variant="dark" header="Relieve de Terreno" class="text-center">
            <b-card-text style = "text-align: center;">{{getPropDisplay('landform')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Ubicación de agua" class="text-center">
            <b-card-text style = "text-align: center;">{{getPropDisplay('water_location')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Presencia de Kudzu" class="text-center">
            <b-card-text style = "text-align: center;">{{getPropDisplay('kudzu')}}</b-card-text>
          </b-card>
        </b-card-group>

        <b-card-group deck>
          <b-card bg-variant="Secondary" text-variant="dark" header="Supervisor CE INMAC" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('username')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Jefe de Obra INMAC" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('supervisor_2')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Supervisión de OT" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('supervisor_3')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Supervisión de Gerencia" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('supervisor_4')}}</b-card-text>
          </b-card>
        </b-card-group>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div v-if="inspection.description!=null">
        <span><b>Descripción / Acciones</b></span>
      </div>
      <div v-if = "typeof text === 'string'">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "text"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div v-if="inspection.obs_ot!=null">
        <span><b>Observación de Oficina Técnica</b></span>
      </div>
      <div v-if = "getProp('obs_ot')">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "getProp('obs_ot')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div v-if="inspection.obs_jt!=null">
        <span><b>Observación de Jefatura</b></span>
      </div>
      <div v-if = "getProp('obs_jt')">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "getProp('obs_jt')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>
    </div>

    <div class="print-container clearfix">
      <div v-if="inspection.image">
        <span><b>Registro Fotográfico</b></span>
      </div>
      <div class="flex-container" style="center">
        <div style="flex-grow: 1">
        </div>
        <div style="flex-grow: 1">
          <b-img thumbnail fluid v-for="(image, key, i) in inspection.image" v-bind:key="'img4_'+i" :id="'img4_'+i"
          style="max-height:400px" class="img-fluid" :src="loadedFiles[key]" alt="Ninguno" :title="key" />
        </div>
        <div style="flex-grow: 1">
        </div>
      </div>
    </div>
    </body>
  </template>
</div>
</template>

<script>
import Base from '../Base.vue'
import jsPDF from 'jspdf'
// import { Radar } from 'vue-chartjs'
import RadarChart from '../../components/chart/RadarChart'
import AttachmentsLoader from '../auxx/AttachmentsLoader'
import store from '../../store'
import Vue from 'vue'

export default {
  extends: Base,
  components: {
    RadarChart
  },
  watch: {
    db (to, from) {
      if (to) {
        this.loadInspection()
      }
    }
  },
  data () {
    return {
      prev_inspection: {},
      inspection: {},
      /* loadedFiles: {}, */
      text: {},
      attachmentsLoader: null,
      selectedImage: 'img4_0',
      selectedSchema: 'img3_0',
      auto: false,
      loadchart: false,
      isMounted: false,
      chartdata: {},
      chartoptions: {},
      schema: null
    }
  },
  computed: {
    bgcolor () {
      if (parseInt(this.getProp('ifrm_value')) <= 10) {
        return 'background-color: rgb(0,176,80)'
      } else if (parseInt(this.getProp('ifrm_value')) <= 20) {
        return 'background-color: rgb(146,208,80)'
      } else if (parseInt(this.getProp('ifrm_value')) <= 32) {
        return 'background-color: rgb(255,255,0)'
      } else if (parseInt(this.getProp('ifrm_value')) <= 42) {
        return 'background-color: rgb(255,192,0)'
      } else {
        return 'background-color: rgb(255,0,0)'
      }
    },
    loadedFiles () {
      if (this.attachmentsLoader) {
        return this.attachmentsLoader.loadedFiles
      }
      return {}
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    loadImages (idxImage, idxEsquema, vattachmentsImage, vattachmentsEsquema) {
      var obj = this
      if (!obj.auto) {
        let AttachmentsLoaderClass = Vue.extend(AttachmentsLoader)
        obj.attachmentsLoader = new AttachmentsLoaderClass({
          router: obj.$router,
          store,
          propsData: {
            idx_image: idxImage,
            idx_esquema: idxEsquema,
            vattachments_image: vattachmentsImage,
            vattachments_esquema: vattachmentsEsquema
          }
        })
        obj.attachmentsLoader.$mount()
      }
    },
    onCancel () {
      let obj = this
      obj.$router.push({ name: 'list', params: { typex: this.$route.params.typex, json: obj.$route.params.json } })
    },
    loadInspection () {
      let obj = this
      if (this.$route.params.id !== '0' && this.$route.params.id !== 0) {
        obj.getdata(this.$route.params.id, obj.auto).then(function (data) {
          var cont = 0
          for (var i in data.image) {
            if (obj.auto && cont === 0) { obj.selectedImage = i }
            if (data.image[i].selected) {
              obj.selectedImage = 'img4_' + cont
              if (obj.auto) { obj.selectedImage = i }
            }
            cont = cont + 1
          }
          cont = 0
          for (i in data.esquema) {
            if (data.esquema[i].selected) { obj.selectedSchema = 'img3_' + cont }
            cont = cont + 1
          }
          obj.$set(obj, 'inspection', data)
          // obj.$set(obj, 'text', data)
          obj.matriz = []
          for (i = 0; i < 9; i++) {
            obj.matriz.push([])
            for (var j = 0; j < 4; j++) {
              obj.matriz[i].push('')
            }
          }
          obj.text = 'Descripción: ' + obj.inspection.description + '\n' + 'Acciones: ' + obj.inspection.action_measure
          /* for (var filename in obj.inspection._attachments) {
            obj.addLoadedFile(filename)
          } */
          var ident = obj.inspection.identification
          obj.db.query('app/checklist', {
            startkey: [ident.flowline, ident.progressive, ident.side_to_ddv, obj.inspection.landslide.inspection_date],
            endkey: [ident.flowline, ident.progressive, ident.side_to_ddv],
            descending: true,
            limit: 2
          }).then(function (res) {
            if (res.rows.length > 0) {
              obj.$set(obj, 'inspection', res.rows[0].value)
            }
            if (res.rows.length > 1) {
              obj.$set(obj, 'prev_inspection', res.rows[1].value)
            }
            var hasifrm = (obj.inspection && obj.inspection.ifrm && obj.inspection.ifrm.ifrm_table)
            var datax = [
              (hasifrm && obj.inspection.ifrm.ifrm_table.pipeline_affectation)
                ? obj.inspection.ifrm.ifrm_table.pipeline_affectation[4] : 0,
              (hasifrm && obj.inspection.ifrm.ifrm_table.floor_slope && obj.inspection.ifrm.ifrm_table.vegetation_cover)
                ? obj.inspection.ifrm.ifrm_table.floor_slope[4] + obj.inspection.ifrm.ifrm_table.vegetation_cover[4] : 0,
              (hasifrm && obj.inspection.ifrm.ifrm_table.containment_works)
                ? obj.inspection.ifrm.ifrm_table.containment_works[4] : 0,
              (hasifrm && obj.inspection.ifrm.ifrm_table.water_presence)
                ? obj.inspection.ifrm.ifrm_table.water_presence[4] : 0,
              (hasifrm && obj.inspection.ifrm.ifrm_table.erosion_control_works)
                ? obj.inspection.ifrm.ifrm_table.erosion_control_works[4] : 0
            ]
            var colorsx = []
            for (var i in datax) {
              var r = parseInt(255 * Math.max((Math.min(1, datax[i] / 5)), 0))
              var g = parseInt(255 - 255 * Math.max((Math.min(1, (datax[i] - 5) / 5)), 0))
              colorsx.push('rgba(' + r + ', ' + g + ', 0, 1)')
              // console.log(i)
            }
            var chartdata = {
              labels: ['AF.D', 'C/P', 'ODC', 'PA', 'OCE'],
              datasets: [{
                label: 'Verificación Radial',
                backgroundColor: 'rgba(12, 24, 34, 0.2)',
                borderColor: colorsx,
                pointBackgroundColor: colorsx,
                data: datax
              }]
            }
            var chartoptions = {
              legend: {
                display: false
              },
              title: {
                display: true,
                text: 'Gráfico de Verificación Radial'
              },
              scale: {
                ticks: {
                  beginAtZero: true,
                  stepSize: 2
                }
              },
              animation: {
                duration: 0
              },
              responsive: false
              // maintainAspectRatio: false
            }
            // obj.$refs.radar.renderChart(chartdata, chartoptions)
            obj.$set(obj, 'chartoptions', chartoptions)
            obj.$set(obj, 'chartdata', chartdata)
            // console.log(chartdata)
            obj.loadchart = true
            // if (!obj.inspection.esquema || Object.keys(obj.inspection.esquema).length === 0) {
            //   obj.cargarSchema()
            // } else {
            obj.loadImages(obj.$route.params.id, obj.$route.params.id, data.image, data.esquema)
            // }
            if (obj.auto) {
              obj.print()
            }
          }).catch(function (err) {
            console.log(err)
          })
          // TODO: unir ambos arreglos de archivos en un arreglo e iterar promesas para mostrarlos
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    cargarSchema () {
      let obj = this
      var id = []
      if (obj.inspection.type || obj.inspection.type === 'plataforma') {
        id = [obj.inspection.identification.platform, obj.inspection.identification.instalation, obj.inspection.identification.talud]
      } else {
        id = [obj.inspection.identification.flowline, obj.inspection.identification.progressive, obj.inspection.identification.side_to_ddv]
      }
      obj.db.query('app/schema', {
        startkey: [...id, obj.inspection.landslide.inspection_date],
        endkey: id,
        descending: true,
        limit: 1,
        include_docs: true,
        attachments: false,
        binary: false
      }).then(function (res) {
        if (res.rows.length > 0) {
          var cont = 0
          for (var elem in res.rows[0].doc.esquema) {
            if (res.rows[0].doc.esquema[elem].selected) {
              obj.selectedSchema = 'img3_' + cont
            }
            cont = cont + 1
          }
          obj.$set(obj.inspection, 'esquema', res.rows[0].doc.esquema)
          var att1 = obj.inspection._attachments || {}
          var att2 = res.rows[0].doc._attachments
          obj.inspection._attachments = { ...att1, ...att2 }
          obj.loadImages(obj.$route.params.id, res.rows[0].doc._id, obj.inspection.images, res.rows[0].doc.esquema)
        } else {
          obj.loadImages(obj.$route.params.id, obj.$route.params.id, obj.inspection.images, obj.inspection.esquema)
        }
      })
    },
    addLoadedFile (id) {
      // this.loadedFiles[id] = window.URL.createObjectURL(this.inspection._attachments[id].data)
    },
    getPropRec (obj, name) {
      if (obj !== null && typeof obj === 'object') {
        if (name in obj) { return obj[name] }
        for (var i in obj) {
          if (i !== 'ifrm_table') {
            var val = this.getPropRec(obj[i], name)
          }
          if (val !== null) { return val }
        }
      }
      return null
    },
    getPropDisplay (name, defaults = '') {
      var value = this.getProp(name, null)
      var children = this.getPropRec(this.metadata, name)
      if (children) {
        for (var i in children.choices) {
          var choice = children.choices[i]
          if (choice.children) {
            for (var j in choice.children) {
              var choice2 = choice.children[j]
              if (choice2.value === value) { return choice2.display_name }
            }
          }
          if (choice.value === value) { return choice.display_name }
        }
      }
      return defaults
    },
    getProp (name, defaults = '') {
      var val = this.getPropRec(this.inspection, name)
      if (val !== null) {
        if (name === 'progressive') {
          var valx
          if (parseInt(val % 1000) > 99) {
            if (parseInt(val / 1000) > 9) {
              valx = parseInt(val / 1000) + '+' + parseInt(val % 1000)
            } else {
              valx = '0' + parseInt(val / 1000) + '+' + parseInt(val % 1000)
            }
          } else if (parseInt(val % 1000) > 9) {
            if (parseInt(val / 1000) > 9) {
              valx = parseInt(val / 1000) + '+0' + parseInt(val % 1000)
            } else {
              valx = '0' + parseInt(val / 1000) + '+0' + parseInt(val % 1000)
            }
          } else {
            if (parseInt(val / 1000) > 9) {
              valx = parseInt(val / 1000) + '+00' + parseInt(val % 1000)
            } else {
              valx = '0' + parseInt(val / 1000) + '+00' + parseInt(val % 1000)
            }
          }
          return valx
        }
        return val
      } else {
        return defaults
      }
    },
    getPropPrev (name, defaults = '') {
      if (this.prev_inspection) {
        var val = this.getPropRec(this.prev_inspection, name)
        if (val !== null) { return val }
      }
      return defaults
    },
    getImageType (img) {
      // var ext = img.src.split('.').pop()
      var type = null
      switch (this.inspection._attachments[img.title].content_type) {
        case 'image/png':
          type = 'png'
          break
        case 'image/gif':
          type = 'gif'
          break
        case 'image/bmp':
          type = 'bmp'
          break
        case 'image/jpeg':
          type = 'jpeg'
          break
        default:
          type = 'jpeg'
          break
      }
      return type
    },
    getAffectation () {
      if (this.inspection && this.inspection.ifrm && this.inspection.ifrm.ifrm_value) {
        if (this.inspection.ifrm.ifrm_value <= 10) { return { t: 'Nivel I', r: 0, g: 176, b: 80 } }
        if (this.inspection.ifrm.ifrm_value <= 20) { return { t: 'Nivel II', r: 146, g: 208, b: 80 } }
        if (this.inspection.ifrm.ifrm_value <= 32) { return { t: 'Nivel III', r: 255, g: 255, b: 0 } }
        if (this.inspection.ifrm.ifrm_value <= 42) { return { t: 'Nivel IV', r: 255, g: 192, b: 0 } }
        return { t: 'Nivel V', r: 255, g: 0, b: 0 }
      }
      return { t: 'Nivel I', r: 255, g: 255, b: 255 }
    },
    print () {
      var obj = this
      /* eslint-disable */
      var doc = new jsPDF('l', 'mm', 'a4')
      /* eslint-enable */
      doc.setDrawColor(0)
      doc.rect(12, 11.2, 275.9, 189.5, 'S')
      doc.rect(14, 43.6, 271, 4.2, 'S')
      doc.setFillColor(204, 255, 255)
      doc.rect(12, 11.2, 275.9, 10.5, 'FD')
      doc.rect(255, 11.2, 32.9, 10.5, 'S')
      doc.rect(12, 11.2, 32.9, 10.5, 'S')
      doc.rect(157.9 + 25 + 17, 49.2, 8.6, 3.5 * 10, 'FD')

      doc.setFillColor(197, 217, 241)
      doc.rect(14, 23, 271, 4.2, 'F')
      doc.rect(14, 49.2, 136.6, 4.2, 'FD')
      doc.rect(14, 90.5, 271, 4.2, 'FD')
      doc.rect(80, 150.5, 205, 4.2, 'FD')

      doc.rect(157.9, 49.2 + 3.5 * 10, 70.3, 3.5, 'FD')

      doc.setFillColor(255, 192, 0)
      doc.rect(14, 27.2, 40, 3, 'F')
      doc.rect(14, 33, 23, 3, 'F')
      doc.rect(39, 33, 23, 3, 'F')

      doc.setFillColor(141, 180, 226)
      doc.rect(157.9, 49.2, 70.3, 3.5, 'FD')
      doc.rect(157.9, 49.2, 25, 3.5 * 10, 'FD')
      for (var i = 0; i < 11; i++) {
        doc.rect(157.9, 49.2 + 3.5 * i, 70.3, 3.5, 'S')
      }

      doc.rect(157.9 + 25, 49.2, 17, 3.5 * 10, 'S')
      doc.rect(157.9 + 25 + 17 + 8.6, 49.2, 10, 3.5 * 10, 'S')
      doc.rect(157.9 + 25 + 17 + 8.6 + 10, 49.2, 9.8, 3.5 * 11, 'S')

      for (i = 0; i < 10; i++) {
        doc.rect(14, 115.5 + i * 3.5, 18.3 + 4 * 31, 3.5, 'S')
      }
      for (i = 0; i < 31; i++) {
        doc.rect(14 + 18.3 + 4 * i, 94.7, 4, 3.5 * 10 + 20.8, 'S')
      }
      doc.rect(14 + 18.3 + 4 * 31, 90.5, 128.7, 4.2 + 3.5 * 10 + 20.8, 'S')

      doc.rect(80, 150.5, 105, 50, 'S')
      doc.rect(185, 150.5, 100, 50, 'S')

      // TEXTO TÍTULO
      doc.setFont('helvetica')
      doc.setFontSize(8)
      doc.text(149, 18, 'CHECK LIST INSPECCIÓN - SEGUIMIENTO PUNTOS DE FALLA REPORTADO Y/O PUNTOS EJECUTADOS', null, null, 'center')

      // TEXTO LINEA MORADA
      doc.setFontSize(6)
      doc.text(256.41, 14, 'Código : MTO-MNT-RE-008')
      doc.text(256.41, 17, 'Versión: 05')
      doc.text(256.41, 20, 'Fecha  : 01/03/2016')
      doc.text(15, 26, 'FECHA REPORTADO: ' + this.getProp('reported_date'))
      doc.text(72.5, 26, 'N° AVISO/ORDEN DE MANTO (OM): ' + this.getProp('om'))
      doc.text(130, 26, 'FLOWLINE: ' + this.getPropDisplay('flowline'))
      doc.text(187.5, 26, 'FECHA INSPECCIÓN: ' + this.getProp('inspection_date'))
      doc.text(245, 26, 'N° INSPECCIÓN: ' + this.getProp('inspection_n'))

      doc.text(15, 29.5, 'N° OM REPORTADO: ' + this.getProp('om_r'))

      // TEXTO COLUMNAS EN BLANCO
      doc.text(15, 32.6, 'Trabajos Provisionales:')
      doc.text(16, 35.6, 'Nro OM: ' + this.getProp('om_pw'))
      doc.text(16, 38.6, 'Ini: ' + this.getProp('pw_start'))
      doc.text(16, 41.6, 'Fin: ' + this.getProp('pw_end'))

      doc.text(40, 32.6, 'Trabajos Definitivos:')
      doc.text(41, 35.6, 'Nro OM: ' + this.getProp('om_dw'))
      doc.text(41, 38.6, 'Ini: ' + this.getProp('dw_start'))
      doc.text(41, 41.6, 'Fin: ' + this.getProp('dw_end'))

      doc.text(68.5, 32.6, 'Inspección Anterior')
      doc.text(69.5, 35.6, 'Fecha     : ' + this.getPropPrev('inspection_date'))
      doc.text(69.5, 38.6, 'Supervisor: ' + this.getPropPrev('supervisor'))

      doc.text(130, 32.6, 'Cota  : ' + Math.trunc(this.getProp('altitude', 0)))
      doc.text(130, 35.6, 'Este  : ' + Math.trunc(this.getProp('east_coordinate', 0)))
      doc.text(130, 38.6, 'Norte : ' + Math.trunc(this.getProp('north_coordinate', 0)))

      doc.text(187.5, 32.6, 'Progresiva    : ' + this.getProp('progressive'))
      doc.text(187.5, 35.6, 'Lado de DDV   : ' + this.getPropDisplay('side_to_ddv'))
      doc.text(187.5, 38.6, 'Sección Transv: ' + this.getPropDisplay('section'))

      /* doc.text(245, 32.6, 'N° Formato')
      doc.line(245, 32, 256, 32) */
      doc.text(245, 35.6, 'Índice FRM Anterior : ' + this.getPropPrev('ifrm_value'))

      // TEXTO LINEA BLANCA
      var affectation = this.getAffectation()
      doc.setFillColor(affectation.r, affectation.g, affectation.b)
      doc.rect(25.5, 44, 5, 3, 'F')
      doc.rect(54, 44, 6, 3, 'F')
      doc.setFontSize(5)
      doc.text(16, 46.2, 'Índice FRM: ' + this.getProp('ifrm_value'))
      doc.text(38, 46.2, 'Nivel de Afectación: ' + affectation.t)
      doc.text(76, 46.2, 'Distancia al ducto: ' + this.getProp('pipeline_distance') + 'm')
      doc.text(109, 46.2, 'Afectación deslizamiento: L=' + this.getProp('landslide_length') + 'm A=' + this.getProp('landslide_width') + 'm Prof t=' + this.getProp('landslide_total_depth') + 'm')
      doc.text(172, 46.2, 'Área Afectada : ' + (Math.PI * Math.sqrt(Math.pow(this.getProp('landslide_length', null), 2) - Math.pow(this.getProp('landslide_total_depth', null), 2)) * this.getProp('landslide_width', null) / 4).toFixed(2) + 'm2')
      doc.text(200, 46.2, 'Prof. Tapada : ' + this.getProp('covered_depth') + 'm')
      doc.text(230, 46.2, 'Tipo de Proceso :  ' + this.getPropDisplay('process_type'))

      // titulos
      doc.setFontSize(6)
      doc.text(82.3, 52.2, 'EVALUACIÓN CUALITATIVA DEL AREA', null, null, 'center')
      doc.text(170.5, 51.6, 'VARIABLE', null, null, 'center')
      doc.text(191.5, 51.6, 'EVALUACIÓN', null, null, 'center')
      doc.text(204, 51.6, '%P', null, null, 'center')
      doc.text(213.5, 51.6, 'V', null, null, 'center')
      doc.text(223.2, 51.6, 'Cn', null, null, 'center')

      doc.text(82.3, 93.1, 'HALLAZGOS', null, null, 'center')
      doc.text(223, 93.1, 'ESQUEMA/PLANO DE PUNTO DE FALLA', null, null, 'center')
      doc.text(132, 153.5, 'DESCRIPCIÓN / ACCIONES', null, null, 'center')
      doc.text(233, 153.5, 'REGISTRO FOTOGRÁFICO', null, null, 'center')

      doc.setFontSize(5)

      var inix = [14, 47, 74, 101, 128, 14, 48, 69, 96, 124]
      var iniy = [56, 56, 56, 56, 56, 74.2, 74.2, 74.2, 74.2, 74.2]
      var cont = 0
      for (i in this.metadata.evaluation.children) {
        var option = this.metadata.evaluation.children[i]
        doc.text(inix[cont], iniy[cont], option.label)
        for (var j = 0; j < option.choices.length; j++) {
          doc.text(inix[cont] + 4, iniy[cont] + 3.5 * (j + 1), option.choices[j].display_name)
          doc.rect(inix[cont], iniy[cont] + 1 + 3.5 * (j), 3.5, 3.5, 'S')
          if (option.choices[j].value === this.getProp(i)) {
            doc.text(inix[cont] + 1, iniy[cont] + 3.5 * (j + 1), 'X')
          }
        }
        cont++
      }

      var ifrmTable = this.getProp('ifrm_table')
      cont = 0
      for (i in ifrmTable) {
        option = ifrmTable[i]
        doc.text(159, 55 + 3.5 * cont, option[0].toString())
        doc.setFontSize(4)
        doc.text(191.5, 55 + 3.5 * cont, option[1].toString(), null, null, 'center')
        doc.setFontSize(5)
        doc.text(204.5, 55 + 3.5 * cont, (option[2] * 100).toFixed(0) + '%', null, null, 'center')
        doc.text(214.5, 55 + 3.5 * cont, option[3].toString(), null, null, 'right')
        doc.text(224.5, 55 + 3.5 * cont, option[4].toString(), null, null, 'right')
        cont++
      }
      doc.text(214.5, 55 + 3.5 * 9, 'IFRM', null, null, 'right')
      doc.text(224.5, 55 + 3.5 * 9, this.getProp('ifrm_value').toString(), null, null, 'right')

      cont = 0
      var findings = this.getProp('findings')
      for (i = 0; i < this.metadata.findings.children.finding.choices.length; i++) {
        option = this.metadata.findings.children.finding.choices[i]
        doc.setFontType('bold')
        doc.text(35 + 4 * cont, 115, option.display_name, null, 90)
        for (j = 0; j < option.children.length; j++) {
          cont++
          doc.setFontType('normal')
          doc.text(35 + 4 * cont, 115, option.children[j].display_name, null, 90)
          for (var k in findings) {
            if (option.children[j].value === findings[k].finding) {
              var cont2 = 0
              for (var l = 0; l < this.metadata.findings.children.finding_location.choices.length; l++) {
                if (this.metadata.findings.children.finding_location.choices[l].value === findings[k].finding_location) {
                  doc.text(33.9 + 4 * cont, 118 + 3.5 * cont2, 'X')
                }
                cont2++
              }
            }
          }
        }
        cont++
      }

      doc.setFontType('normal')
      for (i = 0; i < this.metadata.findings.children.finding_location.choices.length; i++) {
        option = this.metadata.findings.children.finding_location.choices[i]
        doc.text(15, 118 + 3.5 * i, option.display_name)
      }

      inix = [14, 36.8, 59.6]
      iniy = [155.4, 155.4, 155.4]
      cont = 0
      for (i in this.metadata.others.children) {
        option = this.metadata.others.children[i]
        doc.text(inix[cont], iniy[cont], option.label)
        for (j = 0; j < option.choices.length; j++) {
          doc.text(inix[cont] + 4, iniy[cont] + 3.5 * (j + 1), option.choices[j].display_name)
          doc.rect(inix[cont], iniy[cont] + 1 + 3.5 * (j), 3.5, 3.5, 'S')
          if (option.choices[j].value === this.getProp(i)) {
            doc.text(inix[cont] + 1, iniy[cont] + 3.5 * (j + 1), 'X')
          }
        }
        cont++
      }

      doc.text(35, 180, this.getProp('username'), null, null, 'center')
      doc.line(14, 181, 60, 181)
      doc.text(35, 183, 'Supervisor CE INMAC', null, null, 'center')

      doc.line(14, 198, 60, 198)
      doc.text(35, 200, 'Jefe de Obra INMAC', null, null, 'center')

      var texto = 'Descripción: ' + this.getProp('description') +
        '\nAcciones: ' + this.getProp('action_measure')
      var texto2 = doc.splitTextToSize(texto, 102)
      doc.text(texto2, 81, 157)

      try {
        doc.addImage(document.getElementById('img1'), 'JPEG', 13, 12.3, 20, 8)
        var chart1 = document.getElementById('radar-chart')
        var img2 = new Image()
        img2.src = chart1.toDataURL('image/png')

        var height = 38
        var width = 38 / chart1.clientHeight * chart1.clientWidth
        if (width > 80) {
          width = 80
          height = width / chart1.clientWidth * chart1.clientHeight
        }
        doc.addImage(img2, 'png', 257 - width / 2, 48, width, height)
      } catch (err) {
        console.log(err)
      }

      try {
        var img3 = document.getElementById(obj.selectedSchema)
        height = 52
        width = 52 / img3.clientHeight * img3.clientWidth
        if (width > 120) {
          width = 120
          height = width / img3.clientWidth * img3.clientHeight
        }
        doc.addImage(img3, this.getImageType(img3), 220 - width / 2, 96, width, height)
      } catch (err) {
        console.log(err)
      }

      try {
        var img4 = null
        img4 = document.getElementById(obj.selectedImage)
        height = 43
        width = 43 / img4.clientHeight * img4.clientWidth
        if (width > 100) {
          width = 100
          height = width / img4.clientWidth * img4.clientHeight
        }
        doc.addImage(img4, this.getImageType(img4), 235 - width / 2, 156, width, height)
      } catch (err) {
        console.log(err)
      }
      var blob = doc.output('blob')
      window.open(URL.createObjectURL(blob), obj.auto ? '_self' : '_blank')
    }
  }
}
</script>

<style>
li{
  margin: 0px;
  padding: 0px;
}
ul{
  margin: 0px;
  padding: 0px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

}

th, td {
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}

.flex-container {
  display: flex;
  justify-content: stretch;

}

.flex-container > div {
  width: auto;
  margin: 0px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;

  justify-content: center;

}
.invoice-logo {
  height: 50px;
  width: auto;
}

tr:nth-child(even){background-color: #fff}

.print-container {
    max-width: 1250px;
    margin: 5px auto;
    background: white;
    padding: 2px 30px;

  }
  .print-container .header {
    margin-bottom: 0px;
    border-bottom: 0px solid #dbdbdb;
    padding-bottom: 0px;
  }
  .print-container table {
    margin-top: 0px;
  }
  .print-container table tbody tr.no-border:first-child {
    opacity: 0.6 !important;
  }
  .print-container .summary-table {
    border: 1px solid #DDE1E4;
  }
  .print-container .summary-table tr td:last-child {
    text-align: right;
  }
  .print-container .summary-table tr th:last-child {
    text-align: right;
  }
  .print-container .summary-table td {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table th {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table thead {
    color: #737F8B;
    text-transform: uppercase;
  }
  .print-container .ft-18 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .print-container .adder {
    font-size: 16px;
    font-weight: 500;
    text-align: right;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .print-container .total {
    font-size: 22px;
  }
  .print-container .mega {
    font-size: 33px;
    margin-bottom: 10px;
  }
  .row {
    margin-left: 0.0px;
  }
  .card-header{
    font-weight: bold;
  }
  @media print {
    h1, h2, h3, h4, h5, h6 {
      font-weight: bold;
    }
    h1:first-letter, h2:first-letter, h3:first-letter, h4:first-letter, h5:first-letter, h6:first-letter {
      font-size: inherit;
    }
  }

</style>
